import { HTTP } from "@/helpers/http-common"

const url = "/api/perfilUsario"

const get = (data) => new Promise((resolve, reject) => {
  const { username } = data;
  HTTP.get(`${url}/${username}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const update = (data) => new Promise((resolve, reject) => {
  HTTP.put(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default {
  get
  , update
}


// WEBPACK FOOTER //
// ./src/services/seguridad/perfilUsuario/index.js